import { createFileRoute, redirect } from '@tanstack/react-router';

// The Cookie Policy now lives as a section of the consolidated /legal page.
// Keep this URL working for old links and bookmarks by redirecting to it.
export const Route = createFileRoute('/cookies')({
  beforeLoad: () => {
    throw redirect({ to: '/legal', hash: 'cookies' });
  },
});
